import React from 'react';
import { Upload, Icon, Modal, message } from 'antd';
import { url } from '../../../../services/service-utils';
import styles from './index.less';

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

class BannerUpload extends React.Component {
  state = {
    previewVisible: false,
    previewImage: '',
    fileList: [],
  };

  componentDidMount() {
    this.handleInitData(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.handleInitData(nextProps);
  }

  handleImgInfo = (item, index) => {
    return { url: item, uid: `uid-${index}`, name: '图片', status: 'done' };
  };

  handleInitData = props => {
    if (props.fileList && props.fileList.length && typeof props.fileList !== 'string') {
      const fileList = [];
      const that = this;
      props.fileList.forEach((item, index) => {
        fileList.push(that.handleImgInfo(item, index));
      });
      that.setState({
        fileList,
      });
    }
  };

  handleCancel = () => {
    this.setState({ previewVisible: false });
  };

  handlePreview = async file => {
    if (!file.url && !file.preview) {
      // eslint-disable-next-line no-param-reassign
      file.preview = await getBase64(file.originFileObj);
    }

    this.setState({
      previewImage: file.url || file.preview,
      previewVisible: true,
    });
  };

  beforeUpload = file => {
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error('图片不能超过2M!');
    }
    return isLt2M;
  };

  handleChange = ({ file, fileList }) => {
    const that = this;
    const imgPath = [];
    fileList.forEach((item, index) => {
      if (item.response && item.response.code === 0) {
        const { fileUrl } = (item.response && item.response.data) || {};
        // eslint-disable-next-line no-param-reassign
        fileList[index] = that.handleImgInfo((fileUrl && fileUrl.split('?')[0]) || '', index);
        imgPath.push(fileList[index].url);
      } else if (item.url) {
        imgPath.push(item.url);
      }
    });

    that.setState(
      {
        fileList,
      },
      () => {
        if (file.status === 'done' || file.status === 'removed') {
          that.props.callbackImgUrl(imgPath);
        }
      }
    );
  };

  render() {
    const { imageNumber, tips } = this.props;
    const { previewVisible, previewImage, fileList } = this.state;
    const uploadButton = (
      <div className={styles['upload-icon-container']}>
        <Icon type="plus" />
        <div className="ant-upload-text">上传</div>
      </div>
    );
    return (
      <div className="clearfix">
        <Upload
          accept="jpg,png,jepg"
          action={`${url.url}/web/v3/news/file/upload`}
          withCredentials
          listType="picture-card"
          fileList={fileList}
          onPreview={this.handlePreview}
          beforeUpload={this.beforeUpload}
          onChange={this.handleChange}
        >
          {fileList.length >= imageNumber ? null : uploadButton}
        </Upload>
        <Modal visible={previewVisible} centered footer={null} onCancel={this.handleCancel}>
          <img alt="example" style={{ width: '100%' }} src={previewImage} />
        </Modal>
        <div className={styles.notice}>{tips}</div>
      </div>
    );
  }
}

export default BannerUpload;
